module.exports = "<div class=home-nav> <div v-el:scroll class=home-nav-scroll> <ul class=home-nav-list> <li v-for=\"(index,item) in menuList\"> <a :class=\"{'active' : cateid == item.cateid}\" :href=item.href v-touch:tap=onNavTap(index,item.cateid)>{{item.cateName}}</a> </li> </ul> </div> <a class=down @click=onShowMenuClick></a> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/NavigationBar/NavigationBar.vue
 ** module id = 314
 ** module chunks = 4
 **/